import * as React from 'react';

import useRequest from '../../common/services/request';

import CompletedProjectContext from './completed-project.context';

const CompletedProjectProvider = function(props) {
  const request = useRequest();

  const [items, setItems]       = React.useState(props.value?.items || []);
  const [loading, setLoading]   = React.useState(false);
  const [isLoaded, setIsLoaded] = React.useState(items.length > 0);

  const loadItems = React.useCallback(() => {
    setLoading(true);

    return request.get('/api/realizovannye-proekty')
      .then((response) => {
        setItems(response.items);
      })
      .catch(() => {
        setItems([]);
      })
      .finally(() => {
        setIsLoaded(true);
        setLoading(false);
      });
  }, []);

  const context = React.useMemo(() => {
    return {
      items,
      loading,
      isLoaded,
    };
  }, [isLoaded, items, loading]);

  React.useEffect(() => {
    let isUnmounted = false;

    if (!isLoaded) {
      setLoading(true);

      request.get('/api/realizovannye-proekty')
        .then((response) => {
          if (!isUnmounted) {
            setItems(response.items);
          }
        })
        .catch(() => {
          if (!isUnmounted) {
            setItems([]);
          }
        })
        .finally(() => {
          if (!isUnmounted) {
            setIsLoaded(true);
            setLoading(false);
          }
        });
    }

    return () => {
      isUnmounted = true;
    };
  }, []);

  return (
    <CompletedProjectContext.Provider value={context}>
      {props.children}
    </CompletedProjectContext.Provider>
  );
};

export default CompletedProjectProvider;